module.exports = __webpack_public_path__ + "media/site_templates/www.rangehood-installation.com.au/images/our_services_1-b5ceaf467bb0808c68c54fc2cf752240.jpg";